import WidgetEventFaqResourceModel from '../../generated/types/model/resource/WidgetEventFaqResourceModel';

export default class WidgetEventFaqResourceViewModel extends WidgetEventFaqResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
